// @flow
import React from 'react'
import { Grid } from '@material-ui/core'
import i18n from 'i18next'

import Link from '../../Link'
import Damm from './Damm'

type Props = {
  color: string,
  height: number,
  width: number
}

const Logo = (props: Props) => (
  <Grid item xs>
    <Link to={i18n.t('routes.HOME')}>
      <Damm
        color={props.color}
        height={props.height}
        width={props.width}
      />
    </Link>
  </Grid>
)

export default Logo
